module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/sakae_point3_5-36de463fffa7b088e2807dc0243ab435.jpg";